import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon
  const [workspaces, setWorkspaces] = useState([]);
  const [wsId, setWsIdState] = useState(localStorage.getItem("nimbly_ws"));

  const setWsId = (id) => { localStorage.setItem("nimbly_ws", id); setWsIdState(id); };

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("nimbly_token")) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setWorkspaces(data.workspaces);
      const cur = localStorage.getItem("nimbly_ws");
      if (data.workspaces.length && !data.workspaces.find((w) => w.id === cur)) setWsId(data.workspaces[0].id);
      return data;
    } catch {
      localStorage.removeItem("nimbly_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signIn = async (token) => { localStorage.setItem("nimbly_token", token); return refresh(); };
  const signOut = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("nimbly_token");
    localStorage.removeItem("nimbly_ws");
    setUser(false);
  };
  const ws = workspaces.find((w) => w.id === wsId);
  return <Ctx.Provider value={{ user, workspaces, ws, wsId, setWsId, refresh, signIn, signOut }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);

export function Protected({ children }) {
  const { user, workspaces } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center text-sm muted" data-testid="auth-loading">Loading workspace…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (!workspaces.length && loc.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  return children;
}
